import React from "react";
import { Link } from "react-router-dom";
import { Mail, MapPin, Phone, ArrowUpRight } from "lucide-react";

export default function Footer() {
  return (
    <footer className="border-t border-white/5 bg-[#080808] pt-20 pb-10">
      <div className="container-max">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-10 lg:gap-16">
          <div className="lg:col-span-5">
            <div className="flex items-center gap-3 mb-8">
              <div className="w-12 h-12 rounded-xl bg-white flex items-center justify-center flex-shrink-0">
                <span className="font-bebas text-black text-xl leading-none">MDA</span>
              </div>
              <div className="flex flex-col leading-none">
                <span className="font-display font-semibold text-white text-lg tracking-tight">
                  MyDigitalAction<span style={{ color: "#d4ff3d" }}>.</span>
                </span>
                <span className="font-mono-label text-[10px] mt-1" style={{ color: "#d4ff3d", letterSpacing: "0.3em" }}>
                  EXPERIENCE
                </span>
              </div>
            </div>
            <p className="font-display text-3xl lg:text-5xl text-white leading-tight max-w-md">
              Riprendi il<br />
              controllo della tua<br />
              <span className="italic font-light text-white/60">comunicazione digitale.</span>
            </p>
            <a href="#prezzo" className="btn-primary mt-8">
              Iscriviti al percorso <ArrowUpRight size={16} />
            </a>
          </div>

          <div className="lg:col-span-7 grid grid-cols-2 md:grid-cols-4 gap-8">
            <div>
              <div className="font-mono-label text-white/40 text-[11px] mb-4">Naviga</div>
              <ul className="space-y-3">
                {[
                  { l: "Metodo", h: "/#metodo" },
                  { l: "All‑In Experience", h: "/#all-in" },
                  { l: "Formatore", h: "/#formatore" },
                  { l: "Location", h: "/#location" },
                  { l: "FAQ", h: "/#faq" },
                ].map((i) => (
                  <li key={i.l}>
                    <a href={i.h} className="text-white/70 hover:text-white text-sm">
                      {i.l}
                    </a>
                  </li>
                ))}
              </ul>
            </div>

            <div>
              <div className="font-mono-label text-white/40 text-[11px] mb-4">I Corsi</div>
              <ul className="space-y-3">
                {[
                  { l: "Comunicazione Digitale", to: "/landing-corso-cqo" },
                  { l: "Social Media Marketing", to: "/landing-corso-smm" },
                  { l: "Meta Ads Advanced", to: "/landing-corso-fba" },
                  { l: "Customer Loyalty", to: "/landing-corso-cl" },
                  { l: "Agenti AI", to: "/landing-corso-ai" },
                ].map((i) => (
                  <li key={i.to}>
                    <Link
                      to={i.to}
                      className="text-white/70 hover:text-white text-sm inline-flex items-center gap-1 group"
                      data-testid={`footer-course-${i.to.replace("/landing-corso-", "")}`}
                    >
                      {i.l}
                      <ArrowUpRight
                        size={12}
                        className="opacity-0 group-hover:opacity-100 transition-opacity"
                        style={{ color: "#d4ff3d" }}
                      />
                    </Link>
                  </li>
                ))}
              </ul>
            </div>

            <div>
              <div className="font-mono-label text-white/40 text-[11px] mb-4">Contatti</div>
              <ul className="space-y-4">
                <li className="flex items-start gap-3 text-white/70 text-sm">
                  <Mail size={14} className="mt-1 text-lime" style={{ color: "#d4ff3d" }} />
                  <a href="mailto:info@mydigitalaction.it" className="hover:text-white break-all">info@mydigitalaction.it</a>
                </li>
                <li className="flex items-start gap-3 text-white/70 text-sm">
                  <Phone size={14} className="mt-1 text-lime" style={{ color: "#d4ff3d" }} />
                  <span>+39 320 445 9052</span>
                </li>
                <li className="flex items-start gap-3 text-white/70 text-sm">
                  <MapPin size={14} className="mt-1 text-lime" style={{ color: "#d4ff3d" }} />
                  <span>Via Umberto Forti 6<br />56021 Montacchiello, Pisa</span>
                </li>
              </ul>
            </div>

            <div>
              <div className="font-mono-label text-white/40 text-[11px] mb-4">Segui</div>
              <ul className="space-y-3">
                <li><a href="#" className="text-white/70 hover:text-white text-sm inline-flex items-center gap-1">Instagram <ArrowUpRight size={12} /></a></li>
                <li><a href="#" className="text-white/70 hover:text-white text-sm inline-flex items-center gap-1">LinkedIn <ArrowUpRight size={12} /></a></li>
                <li><a href="#" className="text-white/70 hover:text-white text-sm inline-flex items-center gap-1">Facebook <ArrowUpRight size={12} /></a></li>
                <li><a href="https://www.digitalformula.it" target="_blank" rel="noreferrer" className="text-white/70 hover:text-white text-sm inline-flex items-center gap-1">Digital Formula <ArrowUpRight size={12} /></a></li>
              </ul>
            </div>
          </div>
        </div>

        <div className="mt-20 pt-8 border-t border-white/5 flex flex-col lg:flex-row items-start lg:items-center justify-between gap-4">
          <div className="text-white/40 text-xs">
            © {new Date().getFullYear()} Digital Formula di Francesco Gherardi — P.IVA 02124640461. All rights reserved.
          </div>
          <div className="flex gap-6 flex-wrap">
            <Link to="/privacy-policy" className="text-white/40 hover:text-white/70 text-xs" data-testid="footer-privacy-link">Privacy Policy</Link>
            <Link to="/cookie-policy" className="text-white/40 hover:text-white/70 text-xs" data-testid="footer-cookie-link">Cookie Policy</Link>
            <Link to="/termini-condizioni" className="text-white/40 hover:text-white/70 text-xs" data-testid="footer-terms-link">Termini e Condizioni</Link>
            <button
              type="button"
              onClick={() => typeof window !== "undefined" && window.__mdaOpenCookiePreferences && window.__mdaOpenCookiePreferences()}
              className="text-white/40 hover:text-white/70 text-xs"
              data-testid="footer-cookie-prefs-btn"
            >
              Preferenze cookie
            </button>
          </div>
        </div>

        <div className="mt-8 text-white/30 text-[11px] leading-relaxed max-w-3xl">
          Questo sito non fa parte del sito Facebook o Facebook Inc. Inoltre, questo sito NON è approvato da Facebook in
          alcun modo. FACEBOOK è un marchio registrato di FACEBOOK, Inc.
        </div>
      </div>
    </footer>
  );
}
